import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-demo-nine',
  templateUrl: './home-demo-nine.component.html',
  styleUrls: ['./home-demo-nine.component.scss']
})
export class HomeDemoNineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
